import { Box, SxProps } from "@mui/material";

export const ImageFill = ({
  src,
  sx,
  component = "div",
}: {
  src?: string;
  sx?: SxProps;
  component?: string;
}) => {
  return (
    <Box
      component={component as any}
      sx={{
        backgroundImage: src ? `url(${src})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "200px",
        backgroundColor: "#F5F5F5",
        ...sx,
      }}
    />
  );
};
